import React, { Component } from 'react';
import { Configuration } from '../../types/Configuration';
import DWFooter from '../DWFooter/DWFooter';

type Props = {
    selectedLanguage: string,
    configuration: Configuration
}

class Footer extends Component<Props>{
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    addError() {
        this.setState({ hasError: true });
    }

    removeError() {
        this.setState({ hasError: false });
    }

    render() {
        return (
            <DWFooter {...this.props} 
                onErrorCallback={this.addError.bind(this)}
                onLoadCallback={this.removeError.bind(this)} />
        )
    }
}

export default Footer;